module.exports = __webpack_public_path__ + "static/media/procomp.86184f1a.svg";